export default "/images/vendor/flag-icon-css/flags/1x1/ke.svg?c70195b6db5693f8825135e3040d53a1";